import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import NabooPreset from '@/presentation/plugins/presets/presets.ts'
import { ref, computed } from 'vue'

// Créer un état réactif pour le mode sombre
export const isDarkMode = ref(false)

// Fonction pour basculer le mode sombre
export function toggleDarkMode() {
  isDarkMode.value = !isDarkMode.value
  updateTheme()
}

// Fonction pour mettre à jour le thème
function updateTheme() {
  if (isDarkMode.value) {
    localStorage.setItem('theme', 'dark')
  } else {
    localStorage.setItem('theme', 'light')
  }
}

export function initTheme() {
  // Vérifier les préférences stockées
  const savedTheme = localStorage.getItem('theme')

  // Vérifier si l'utilisateur a déjà une préférence dans localStorage
  if (savedTheme) {
    isDarkMode.value = savedTheme === 'dark'
  } else {
    // Sinon, vérifier les préférences du système
    isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  updateTheme()

  // Écouter les changements de préférence système
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
    if (localStorage.getItem('theme') === null) {
      isDarkMode.value = event.matches
      updateTheme()
    }
  })
}

export const registerNabooPrimeVueConfig = (app: App) => {
  // Initialiser le thème avant de configurer PrimeVue
  initTheme()

  app.use(PrimeVue, {
    // Configuration du thème Aura
    theme: {
      preset: NabooPreset,
      options: {
        prefix: 'p',
        // Mode sombre dynamique selon la classe .dark
        darkModeSelector: false,
        // Configuration correcte des layers CSS
        cssLayer: {
          name: 'primevue',
          order: 'app-styles, base, primevue, components, utilities'
        }
      }
    },
    // Passer l'état du dark mode comme contexte
    contextValue: computed(() => ({
      isDark: isDarkMode.value
    }))
  })
}
